import { useDocumentTitle, useFavicon, useFetch } from '@mantine/hooks';
import { ICourse } from '../interfaces/ICourse.tsx';
import { Divider, Flex, Grid, Loader, Title, Transition } from '@mantine/core';
import { useEffect, useState } from 'react';
import CourseCard from '../components/courses/card.tsx';
import { useTranslation } from 'react-i18next';

export function ProCourses() {
  const { t } = useTranslation();
  useDocumentTitle('BECOME | Tutti i corsi ECM');
  useFavicon('/favicon.ico');
  const [mountedCards, setMountedCards] = useState<number[]>([]);
  const { data, loading, refetch } = useFetch<{ data: ICourse[] }>(
    `${import.meta.env.VITE_API_URL}/services/userCourses`,
    {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  useEffect(() => {
    if (data) {
      data.data
        ?.filter(i => i.ecm > 0)
        .forEach((_, index) => {
          setTimeout(() => {
            setMountedCards(prev => [...prev, index]);
          }, 50 * index); // Add a delay of 50ms per card
        });
    }
  }, [data]);

  // Refetch data when the page becomes visible (user returns to this page)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        refetch();
      }
    };

    const handleFocus = () => {
      refetch();
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleFocus);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleFocus);
    };
  }, [refetch]);

  return (
    <>
      <Flex direction={'column'}>
        <Title>{t('pro_courses', 'LIBRERIA CORSI FAD ECM')}</Title>
        <Title order={4} c={'dimmed'}>
          Trova qui tutti i corsi a catalogo e quelli che hai acquistato
        </Title>
      </Flex>
      <Divider mb={'md'} mt={'md'} />
      <Grid
        gutter={{ base: 5, xs: 'md', md: 'xl' }}
        mt={'md'}
        style={{ minHeight: 150 }}
        p={{ base: 20, xs: 0 }}
      >
        {loading ? (
          <Grid.Col span={12} ta={'center'}>
            <Loader />
          </Grid.Col>
        ) : (
          data?.data
            .sort((a, b) => (a.unlocked ? 0 : 1) - (b.unlocked ? 0 : 1))
            .filter(i => i.ecm > 0)
            .map((c: ICourse, index: number) => (
              <Transition
                key={c.id}
                transition='fade-left'
                duration={240}
                timingFunction='ease'
                onEnter={() => {}}
                mounted={mountedCards.includes(index)}
              >
                {styles => (
                  <Grid.Col
                    span={{
                      base: 12, // telefono
                      xs: 6, // schermo leggermente più largo
                      sm: 4, // tablet piccolo
                      md: 3, // tablet grande
                      lg: 2, // desktop
                      xl: 2, // desktop grande
                    }}
                    mb={{ base: 20, xs: 0 }}
                  >
                    <CourseCard c={c} style={styles} />
                  </Grid.Col>
                )}
              </Transition>
            ))
        )}
      </Grid>
    </>
  );
}
